/**
 * Mirror del catálogo de límites del backend (`backend/app/core/plan_limits.py`).
 * El backend siempre es la autoridad — esto es solo para UX (mostrar "2/2 cuentas",
 * deshabilitar botones, etc.). Si los valores cambian, actualizar AMBOS archivos.
 *
 * Nota: max_categorias incluye las 15 default que el seed crea para cada usuario
 * nuevo (no hay flag is_default en la tabla). Por eso gratis = 20 (15 + 5 extras).
 */
export const PLAN_LIMITS = {
  gratis: {
    max_cuentas: 2, max_tdc: 1, max_metas: 1, max_presupuestos: 5,
    max_categorias: 20, max_msi_activas: 5, max_recurrentes: 5,
    duky_messages_month: 30, voz_records_month: 10,
    comparativa_meses: false, proyeccion: false, exportar_datos: true,
  },
  basico: {
    max_cuentas: 8, max_tdc: 5, max_metas: 5, max_presupuestos: 15,
    max_categorias: 30, max_msi_activas: 20, max_recurrentes: 20,
    duky_messages_month: 200, voz_records_month: 60,
    comparativa_meses: false, proyeccion: false, exportar_datos: true,
  },
  pro: {
    max_cuentas: 15, max_tdc: 10, max_metas: 10, max_presupuestos: 30,
    max_categorias: 45, max_msi_activas: 40, max_recurrentes: 40,
    duky_messages_month: 500, voz_records_month: 150,
    comparativa_meses: true, proyeccion: true, exportar_datos: true,
  },
};

export const PLAN_LABELS = {
  gratis: "Gratis",
  basico: "Básico",
  pro: "Pro",
};
